import PropTypes from "prop-types";

import { t } from "../../services";
import { PagesWrapper } from "./styled";
import OptionButton from "../OptionButton/OptionButton";

const TabSelector = ({
  pages,
  activePage,
  setActivePage = () => {},
  disabled,
  lastActiveIndex
}) => {
  return (
    <PagesWrapper>
      {pages?.map((page) => {
        return (
          <OptionButton
            key={page.id}
            disabled={disabled || page.id > lastActiveIndex}
            onClick={() => setActivePage(page.id)}
            isActive={activePage === page.id}>
            {t(page.title)}
          </OptionButton>
        );
      })}
    </PagesWrapper>
  );
};

TabSelector.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string.isRequired, title: PropTypes.string.isRequired })
      .isRequired
  ),
  disabled: PropTypes.bool,
  activePage: PropTypes.string,
  lastActiveIndex: PropTypes.string,
  setActivePage: PropTypes.func.isRequired
};

export default TabSelector;
